import {
    BUSINESS_EVENTBRITE_CATEGORY,
    COMMUNITY_EVENTBRITE_CATEGORY,
    FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PARTY_EVENTBRITE_FORMAT,
    PERFORMING_EVENTBRITE_CATEGORY,
} from '../../../../../constants';

//filter the returned formats/categories against this list
export const topCategories = [
    MUSIC_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    BUSINESS_EVENTBRITE_CATEGORY,
    FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    COMMUNITY_EVENTBRITE_CATEGORY,
];
export const topFormats = [PARTY_EVENTBRITE_FORMAT];

//include topPrice if suggestedTags > 3 options
export const topPrice = ['free'];

//include dates on priority represented in this list
export const topDates = ['this_weekend'];

export const GA_SEARCH_REDIRECTION_CATEGORY = 'search-end-results-redirection';
